import { ReactNode, useId } from "react";

import Radio from "../../Radio";

type TileIndicatorProps = {
  indicator: "radio" | ReactNode;
  selected?: boolean;
  disabled?: boolean;
};

const TileIndicator = ({ indicator, selected, disabled }: TileIndicatorProps) => {
  const id = useId();

  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (indicator) {
    case "radio":
      // Visual only — the tile itself carries the radio role and keyboard handling
      return <Radio id={id} checked={selected} disabled={disabled} tabIndex={-1} aria-hidden />;
    default:
      return <>{indicator}</>;
  }
};

TileIndicator.displayName = "DS.Tile.Indicator";

export default TileIndicator;
